import { Field } from '../../../components/field/field';
import { SelectForm } from '../../../components/select-form/select-form';
import { GeneralLedgerAccount } from '../../../clients/quipli-service/accounting/accounting';

export interface CustomLineItemFormProps {
  description?: string;
  setDescription: (d: string) => void;
  name: string;
  setName: (d: string) => void;
  generalLedgerAccount?: GeneralLedgerAccount;
  setGeneralLedgerAccount: (acc?: GeneralLedgerAccount) => void;
  accounts: GeneralLedgerAccount[];
  errors?: {
    name?: string;
    description?: string;
  };
}

export const CustomLineItemForm = ({
  description,
  setDescription,
  name,
  setName,
  generalLedgerAccount,
  setGeneralLedgerAccount,
  accounts,
  errors,
}: CustomLineItemFormProps) => {
  return (
    <>
      <Field
        label="Name"
        isRequired
        type="text"
        value={name}
        onChange={(v) => setName(v)}
        dataCy="field_name"
        invalid={!!errors?.name}
        description={errors?.name}
      />
      <Field
        label="Description"
        type="text"
        value={description}
        onChange={(v) => setDescription(v)}
        dataCy="custom_field_description"
        invalid={!!errors?.description}
        description={errors?.description}
      />
      <SelectForm
        label="General Ledger Account"
        value={
          generalLedgerAccount
            ? {
                label: generalLedgerAccount?.name,
                value: generalLedgerAccount?.id,
              }
            : undefined
        }
        menuPortalTarget={document.body}
        onChange={(v) => v && setGeneralLedgerAccount(accounts?.find((a) => a.id === v.value))}
        options={accounts?.map((a) => ({ label: a.name, value: a.id }))}
        dataCy="custom_field_gla"
      />
    </>
  );
};
